import { tsGetAnimalsInContainer } from '../../../Typescript/API_Response'

export interface tsStorageAnimalMeta {
  OrganType: string
  StorageMedia: string
  FreezingMethod: string
  MethodEuthanasia: string
  SampleDetails: string
  NumSamples?: string
  BPID?: string
}

export interface tsAddSample {
  message?: string
  sampleID: string
  valid?: boolean
  metadata?: tsStorageAnimalMeta
}

export interface tsAddAnimal {
  [key: string]: tsAddSample[]
}

export function validSamplesState(
  animals: tsAddAnimal,
  collection: tsGetAnimalsInContainer,
  storage: boolean = false,
  containerMeta?: any,
  isRunType570: boolean = false,
) {
  // at least one sampleID
  if (
    Object.values(animals).filter(
      (samples) => samples.filter(({ sampleID }) => sampleID).length > 0,
    ).length === 0
  ) {
    return false
  }
  // all animals accounted for
  if (Object.keys(animals).length !== collection.animals.length) {
    return false
  }
  let returnValid = true
  Object.values(animals).forEach((samples) => {
    samples!.forEach(({ valid, sampleID, metadata }) => {
      if (!valid || !sampleID) {
        returnValid = false
      }
      //STU-1821 storage specific mandatory fields
      if (storage) {
        if (isRunType570) {
          returnValid = !!metadata?.FreezingMethod
        } else {
          // For other RunTypes (e.g., 550), check the original fields
          if (
            !metadata?.FreezingMethod ||
            !containerMeta?.MethodEuthanasia ||
            !metadata?.OrganType ||
            !metadata?.StorageMedia
          ) {
            returnValid = false
          }
        }
      }
    })
  })
  return returnValid
}
